module.exports = __webpack_public_path__ + "media/walk.dfd67193.mp4";